<template>
</template>

<script>
export default {
    name: "LoginPage",
    created() {
        var returnUrl = localStorage.getItem("returnUrl");
        localStorage.removeItem("returnUrl");
        this.$router.push(
            returnUrl
        );
    }
};
</script>
